"use client";

import { Button, Input, Textarea } from "@heroui/react";
import { useFormStatus } from "react-dom";
import { submitContactForm } from "@/app/(platform)/about-techno-music-world/actions";
import { useEffect, useRef } from "react";
import { useActionState } from "react";

function SubmitButton() {
  const { pending } = useFormStatus();

  return (
    <Button
      color="primary"
      type="submit"
      className="text-primary-foreground font-semibold tracking-wider rounded-md uppercase mt-4 w-36"
      variant="shadow"
      isLoading={pending}
    >
      {pending ? "Sending..." : "Send"}
    </Button>
  );
}

export default function ContactForm() {
  const formRef = useRef<HTMLFormElement>(null);
  const [state, formAction] = useActionState(submitContactForm, null);

  // Reset form when submission is successful
  useEffect(() => {
    if (state?.success) {
      formRef.current?.reset();
    }
  }, [state?.success]);

  return (
    <form ref={formRef} action={formAction} className="max-w-2xl w-full">
      <div className="flex space-x-4">
        <Input
          variant="bordered"
          className="h-12"
          classNames={{ inputWrapper: "rounded-md" }}
          label="First Name"
          name="firstName"
          isRequired
        />
        <Input
          variant="bordered"
          className="h-12"
          classNames={{ inputWrapper: "rounded-md" }}
          label="Last Name"
          name="lastName"
        />
      </div>
      <div className="flex flex-col items-center">
        <Input
          variant="bordered"
          className="h-12 mt-4"
          classNames={{ inputWrapper: "rounded-md" }}
          label="Email"
          type="email"
          name="email"
          isRequired
        />
        <Textarea
          label="Message"
          variant="bordered"
          className="mt-4"
          classNames={{ inputWrapper: "rounded-md" }}
          placeholder="Enter your message"
          name="message"
          isRequired
        />

        {state?.error ? (
          <p className="mt-4 text-status-negative">{state.error}</p>
        ) : state?.success ? (
          <p className="mt-4 text-status-positive">Message sent successfully!</p>
        ) : null}

        <SubmitButton />
      </div>
    </form>
  );
}
